/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as vscode from 'vscode';
import { $gnc } from '../commandManager';
import { $rnc } from '../markdownEngine';
import { $4nc } from '../preview/previewManager';
import { ContentSecurityPolicyArbiter, $Snc } from '../preview/security';
import { TelemetryReporter } from '../telemetryReporter';
import { $doc, $eoc } from './insertResource';
import { $foc } from './refreshPreview';
import { $goc } from './reloadPlugins';
import { $hoc } from './renderDocument';
import { $koc, $ioc, $joc } from './showPreview';
import { $loc } from './copyImage';
import { $moc } from './showPreviewSecuritySelector';
import { $noc } from './showSource';
import { $ooc } from './toggleLock';

export function $poc(
	commandManager: $gnc,
	previewManager: $4nc,
	telemetryReporter: TelemetryReporter,
	cspArbiter: ContentSecurityPolicyArbiter,
	engine: $rnc,
): vscode.Disposable {
	const previewSecuritySelector = new $Snc(cspArbiter, previewManager);

	commandManager.register(new $loc(previewManager));
	commandManager.register(new $ioc(previewManager, telemetryReporter));
	commandManager.register(new $joc(previewManager, telemetryReporter));
	commandManager.register(new $koc(previewManager, telemetryReporter));
	commandManager.register(new $noc(previewManager));
	commandManager.register(new $foc(previewManager, engine));
	commandManager.register(new $moc(previewSecuritySelector, previewManager));
	commandManager.register(new $ooc(previewManager));
	commandManager.register(new $hoc(engine));
	commandManager.register(new $goc(previewManager, engine));
	commandManager.register(new $doc());
	commandManager.register(new $eoc());

	return commandManager;
}
